import child from './child';

// ----------------------------------------------------------------------------

function childArray(element: HTMLElement, arr: any[]): void {
    if (!Array.isArray(arr)) {
        arr = [arr];
    }

    for (const item of arr) {
        child(element, item);
    }
}

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        childArray(arr: any[]): HTMLElement;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.childArray = function (arr: any[]): HTMLElement {
    childArray(this, arr);

    return this;
};

// ----------------------------------------------------------------------------

export default childArray;
